// removed by extract-text-webpack-plugin
module.exports = {"main-container":"main-container","header":"header","left-container":"left-container","statistic-container":"statistic-container","data-wrapper":"data-wrapper","number":"number","select":"select","chart-wrapper":"chart-wrapper","right-container":"right-container","schedule-wrapper":"schedule-wrapper","log-wrapper":"log-wrapper","block-wrapper":"block-wrapper","description":"description","tooltip":"tooltip","tooltipDate":"tooltipDate","circle":"circle","description-wrapper":"description-wrapper","graph-labels":"graph-labels","graph-label":"graph-label"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/pages/Dashboard/style.scss
// module id = DNRm
// module chunks = 0